import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type StoreService from 'ember-data/store';
import type RouterService from '@ember/routing/router-service';
import type SessionContextService from 'tio-employee/services/session-context';
import type FeaturesService from 'tio-common/services/features';
import type PersonModel from 'tio-data/models/person';

export default class AuthenticatedSlrLrapEnrollmentRoute extends Route {
  @service declare store: StoreService;
  @service declare router: RouterService;
  @service declare sessionContext: SessionContextService;
  @service declare features: FeaturesService;

  async beforeModel() {
    if (this.features.isDisabled('lrapEnrollment')) {
      this.router.transitionTo('authenticated.slr.dashboard');
      return;
    }

    // TODO: Also redirect already-enrolled users once enrollment state is
    // tracked server-side (e.g. this.sessionContext.currentEmployee?.lrapEnrolledAt).
  }

  async model() {
    const personId = this.sessionContext.person.id;
    if (!personId) {
      throw new Error('Cannot load LRAP enrollment without a person id.');
    }
    const person = await this.store.findRecord<PersonModel>('person', personId, {
      include: 'email-addresses,postal-addresses',
      reload: true,
    });
    return { person };
  }
}

export interface AuthenticatedSlrLrapEnrollmentRouteModel {
  person: PersonModel;
}
